import { Request as request } from "@/utils/request";

/**
 * 创建 TON 订单2
 * @param {{
* id: string,
* }} params
* @obj {{
    "code": 200,
    "data": {
        "order_id": "xxxx", // 订单号
        "url": "xxx" // 付款的钱包地址
    }
}}
* @returns {Promise<obj>} 返回服务器响应
* 
*/
let createOrderV2 = (params) => {
  return request("/api/common_v3/ton-create-order", {
    method: "POST",
    params,
  });
};

/**
 * 检查 TON 订单状态2
 * @param {string} order_id 生成订单返回的订单号
 * @returns {Promise<Object>} 返回服务器响应
 * {
 * "code": 200,
 * "data": "wait" // wait: 等待付款，success: 付款成功
 * }
 */
let checkOrderStatusV2 = (order_id) => {
  return request("/api/common_v3/ton-check-order", {
    method: "POST",
    params: { order_id },
  });
};

/**
 * 获取提现列表
 * @returns
 */
let getWithdrawList = () => {
  return request("/api/miner/withdrawals-list", {
    method: "POST",
  });
};

/**
 * 检查支付状态 AI
 * @param {object} params
 * @param {string} params.id 订单id
 * @returns
 */
let checkPaymentStatusAI = (params) => {
  return request("/api/common_v4/check-order", {
    method: "POST",
    params,
  });
};

/**
 * 佣金提现记录
 * @returns {Promise<Object>} 返回服务器响应
 */
let withdrawalsList = (params) => {
  return request("/api/common/commission-list", {
    method: "POST",
    params,
  });
};
/**
 * 佣金提现
 * @param {{
 * amount: number,
 * }} params
 * @returns {Promise<Object>} 返回服务器响应
 */
let commissionSubmit = (params) => {
  return request("/api/common/commission-submit", {
    method: "POST",
    params,
  });
};

/**
 * 领取分红
 * @returns {Promise<Object>} 返回服务器响应
 */
let claimDividends = () => {
  return request("/api/common/claim-dividends", {
    method: "POST",
  });
};
/**
 * 提现
 * @param {object} params
 * @param {string} params.amount 提现金额
 * @param {string} params.address 提现地址
 * @param {string} params.token_name 提现币种
 * @param {string} params.share 分享组群数
 * @returns
 */
let convert = async (params) => {
  return request("/api/common/convert-v5", {
    method: "POST",
    params,
  });
};
/**
 * 提交付款
 * @param {object} params
 * @param {string} params.payment_type 钱包类型
 * @param {string} params.payment_info 钱包地址
 * @returns
 */
let paymentSubmit = (params) => {
  return request("/api/common/payment-submit", {
    method: "POST",
    params,
  });
};
/**
 * 提交付款
 * @param {object} params
 * @param {string} params.payment_type 钱包类型
 * @param {string} params.payment_info 钱包地址
 * @returns
 */
let updatePayment = (params) => {
  return request("/api/common/update-payment", {
    method: "POST",
    params,
  });
};
/**
 * 加速提现
 * @param {object} params
 * @param {string} params.id 提现id
 * @param {string} params.share 分享组群数
 * @param {string} params.over_task 完成任务数
 * @param {string} params.send_message_num 发送消息数
 * @returns
 */
let acceleratedWithdrawals = (params) => {
  return request("/api/common/accelerated-withdrawals", {
    method: "POST",
    params,
  });
};
export {
  createOrderV2,
  checkOrderStatusV2,
  getWithdrawList,
  checkPaymentStatusAI,
  withdrawalsList,
  commissionSubmit,
  claimDividends,
  convert,
  paymentSubmit,
  acceleratedWithdrawals,
  updatePayment,
};
